<script lang="ts">
  import type { Notice } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  const statusDecorations = {
    success: { textColor: "fizz-text-positive", icon: "CheckCircle" },
    warning: { textColor: "fizz-text-warning", icon: "Info" },
    error: { textColor: "fizz-text-negative", icon: "Info" },
    info: { textColor: "fizz-text-subdued", icon: null },
  };

  export let notice: Notice;
  export let iconOverride: string = null;

  $: icon = iconOverride || statusDecorations[notice.level].icon;
</script>

<span
  class="{statusDecorations[notice.level].textColor} fizz-flex-row-4 fizz-stack-4"
  data-testid="cart-widget-notice-{notice.level}"
>
  {#if icon}
    <Icon className="fizz-icon-16" type={icon} />
  {/if}
  <p>
    {notice.message}
    <slot />
  </p>
</span>
